import React from "react"
import { Radio as MUIRadio, RadioProps as MUIRadioProps } from "@mui/material"
import { MUIMappedRadio } from "./mantine/Radio.mantine"

export type RadioProps =
  | ({ new?: false } & MUIRadioProps)
  | ({ new: true } & MUIRadioProps)

export const Radio = React.forwardRef<HTMLButtonElement, RadioProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedRadio {...props} ref={ref} />
    ) : (
      <MUIRadio {...props} ref={ref} />
    ),
)

Radio.displayName = "Radio"

export default Radio
